"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _dropper = _interopRequireDefault(require("./dropper"));
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _view = /*#__PURE__*/new WeakMap();
var Extension = exports["default"] = /*#__PURE__*/function () {
  function Extension() {
    (0, _classCallCheck2["default"])(this, Extension);
    _classPrivateFieldInitSpec(this, _view, null);
    this.renderView();
  }
  return (0, _createClass2["default"])(Extension, [{
    key: "renderView",
    value: function renderView() {
      if (!_classPrivateFieldGet(_view, this)) {
        _classPrivateFieldSet(_view, this, Entry.Dom('div', {
          "class": 'entryExtension',
          parent: $('body')
        }));
      }
    }
  }], [{
    key: "getExtension",
    value: function getExtension(key) {
      switch (key) {
        case 'Dropper':
          return _dropper["default"].getInstance();
      }
    }
  }]);
}();